import type { IModule, IQService } from "angular";
import { module } from "angular";

import "moment-duration-format";
import moment from "moment-timezone";
import "angular-cookies";
import "angular-moment";
import "angular-local-storage";

import type { IServiceWorkerService } from "App/Modules/Services/ServiceWorker/IServiceWorkerService";

import "angular-translate-loader-url";
import GlobalisationConfig from "./GlobalisationConfig";

export const app: IModule = module("mmGlobalisation", ["ngCookies", "pascalprecht.translate", "angularMoment"])
    .config(GlobalisationConfig)
    .constant("angularMomentConfig", {
        // This uses the right moment instance (with timezone support)
        // but gives annoying warning in console "changeTimezone() works only with moment-timezone.js v0.3.0 or greater."
        preprocess: (value) => moment(value),
    })
    .run([
        "irServiceWorker",
        (serviceWorker: IServiceWorkerService) => {
            serviceWorker.register("/translationCache.js");
        },
    ])
    .factory("i18nLanguageCacheLoader", [
        "localStorageService",
        "$q",
        "$translateUrlLoader",
        ($localStorageService: angular.local.storage.ILocalStorageService, $q: IQService, $translateUrlLoader: any) => {
            return (options) => {
                const deferred = $q.defer();

                // Try to load from i18n local storage
                // Saved in React bootstrapping, for example siteslist on dashboard
                ($localStorageService as any).setPrefix("ir.");

                const storageKey = `langs.${options.key}-translation`;
                const translations = $localStorageService.get(storageKey);

                // Check cache set "today" or "yesterday"
                const isValid = translations?.i18nVersion === new Date().toISOString().substring(0, 10);
                if (isValid) {
                    deferred.resolve(translations);
                } else {
                    return $translateUrlLoader(options);
                }
                return deferred.promise;
            };
        },
    ])
    .service("irLanguageCacheService", [
        "localStorageService",
        ($localStorageService: angular.local.storage.ILocalStorageService) => {
            return {
                clearCache: () => {
                    // Try to load from i18n local storage
                    // Saved in React bootstrapping, for example siteslist on dashboard
                    ($localStorageService as any).setPrefix("ir.");

                    $localStorageService
                        .keys()
                        .filter((key) => /langs\...-translation/.test(key))
                        .forEach((key) => {
                            $localStorageService.remove(key);
                        });
                    // eslint-disable-next-line
                    console.warn("Cleared translations cache, reload page to rehydrate.");
                },
            };
        },
    ]);
